export default "__VITE_ASSET__BeWJoKRQ__"